import type { PreviewData, SelectedScreenMeta } from '@/features/campaigns/types/campaign';

export function normalizeOrientations(
  value: PreviewData['requiredOrientation'] | string | undefined,
): Array<'PORTRAIT' | 'LANDSCAPE'> {
  if (!value) return [];
  const list = Array.isArray(value) ? value : [value];
  const out = new Set<'PORTRAIT' | 'LANDSCAPE'>();
  for (const item of list) {
    const upper = String(item).toUpperCase();
    if (upper.includes('PORTRAIT')) out.add('PORTRAIT');
    if (upper.includes('LANDSCAPE')) out.add('LANDSCAPE');
  }
  return [...out];
}

/** Clear copy when screen orientation and uploaded content don't match. */
export function buildOrientationWarningCopy(
  required: Array<'PORTRAIT' | 'LANDSCAPE'>,
  currentMediaOrientation: string,
) {
  const requiredLabel = required.join(' & ');
  const current = currentMediaOrientation || 'a different orientation';

  const title =
    required.length === 1
      ? `All selected screens are ${required[0]} — your content is ${current}`
      : `Selected screens need ${requiredLabel} — your content is ${current}`;

  const uploadHint =
    required.length === 1
      ? `please upload ${required[0]} content`
      : `please upload matching ${requiredLabel} content`;

  return {
    title,
    body: `AI can convert it for you, but quality may be affected. For best results, ${uploadHint}.`,
  };
}

function nestedBillboard(row: Record<string, unknown>) {
  const nested = row.billboardId;
  if (nested && typeof nested === 'object') {
    return nested as Record<string, unknown>;
  }
  return null;
}

export function screenNameFromRow(
  row: Record<string, unknown>,
  meta?: SelectedScreenMeta,
) {
  const nested = nestedBillboard(row);
  return String(
    nested?.screenName ||
      row.screenName ||
      row.name ||
      row.billboardName ||
      meta?.screenName ||
      '',
  );
}

export function idFromRow(row: Record<string, unknown>) {
  const nested = nestedBillboard(row);
  return String(
    nested?._id || nested?.id || row.billboardId || row._id || row.id || '',
  );
}
